<template>
  <div id='photos'>
    <p>Photos</p>
    <div class="card-columns">
      <div class="card card-image-top imgContain align-middle" v-for="photo in photos" :key='photo.dateAdded' >
        <img class="card-img-top" v-bind:src="photo.url">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'photos',
  data () {
    return {
      photos: ''
    }
  },
  mounted () {
    this.$http.get('/photos?query={"display":true}').then(response => {
      this.photos = response.data
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Photos.vue